export const YAxisHorizontalWrapFactor = 70;
export const XAxisHorizontalWrapFactor = 80;
/**
 * Wrap a string depending on a width, a horizontalWrapFactor and a maxNumberLine.
 * The text will be split into lines of a size that depends on the width and the horizontalWrapFactor.
 * The maximum number of characters per line is going to be width (px) / horizontalWrapFactor. It allows to have
 * a dynamic number of characters per line that depends on the width of the chart.
 * The maximum number of lines is equal to maxNumberLine, ... are added at the end when the number of lines
 * is superior than maxNumberLine.
 */
export function wrap(
    val: string,
    width: number,
    horizontalWrapFactor: number,
    maxNumberLine: number,
): string {
    // It represents the maximum number of characters per line
    const widthFactor = Math.round(width / horizontalWrapFactor);
    // It represents the maximum number of lines
    const heightFactor = maxNumberLine;

    const words = val.split(' ');
    let output = '';
    let line = '';
    let numberLines = 0;

    for (let i = 0; i < words.length; i += 1) {
        const newLine = `${line} ${words[i]}`;
        if (newLine.length <= widthFactor) {
            // If there is enough space in the current line, we add the word
            if (line.length !== 0) {
                line += ' ';
            }
            line += words[i];
            // If there is not enough space in the current line, we have 2 cases
        } else if (
            words[i].length <= widthFactor &&
            numberLines + 1 < heightFactor
        ) {
            // 1 - the word length is smaller than the maximum number of chars by line
            // and there is space to add a new line.
            // => we add the word in the next line
            output = `${output + line}\n`;
            numberLines += 1;
            line = words[i];
        } else {
            // 2 - the word is longer than the maximum number of chars by line
            // => we cut the word in 2
            // Note: it doesn't work correctly if the second part of the word is still longer
            // then the maximum number of chars by line. To fix later if it is an issue.
            if (line.length !== 0) {
                line += ' ';
            }
            const cutIndex = widthFactor - line.length;
            line += words[i].substring(0, cutIndex);
            if (numberLines + 1 === heightFactor) {
                output += line;
                output = `${output.substring(0, output.length - 3)}...`;
                numberLines += 1;
                break;
            } else {
                output = `${output + line}\n`;
                numberLines += 1;
            }
            line = words[i].substring(cutIndex);
        }
    }
    // We add the last line if possible
    if (numberLines < heightFactor) {
        output += line;
    }
    return output;
}
